import React from "react";

export default function TetFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-6tet2{fill:#ce3117}.cls-6tet3{fill:#1e5103}.cls-6tet4{fill:#aa1b09}.cls-6tet5{fill:#0f4908}.cls-6tet7{fill:#330c07}.cls-6tet8{fill:#3f8918}.cls-6tet9{fill:#23601a}"
            }
          </style>
        </defs>
        <path
          d="M1485.72 1788.32H508.45c-64.12 0-124.4-24.97-169.74-70.31s-70.31-105.62-70.31-169.74V322.14c0-64.12 24.97-124.4 70.31-169.74s105.62-70.31 169.74-70.31h977.27c64.12 0 124.4 24.97 169.74 70.31s70.31 105.62 70.31 169.74v1226.14c0 64.12-24.97 124.4-70.31 169.74s-105.62 70.31-169.74 70.31ZM508.45 120.04c-111.44 0-202.1 90.66-202.1 202.1v1226.14c0 111.44 90.66 202.1 202.1 202.1h977.27c111.44 0 202.1-90.66 202.1-202.1V322.14c0-111.44-90.66-202.1-202.1-202.1H508.45Z"
          className="cls-6tet7"
        />
        <path
          d="M1280.58 1388.78c-5.86 0-11.34-3.92-14.29-8.1-4.84-6.85-3.25-14.56-2.34-17.56 1.67-5.5 5.32-9.29 8.77-11.77-1.73-.37-3.46-.53-5.11-.46-11.54.48-24.26 12.58-24.69 31.29a2.286 2.286 0 0 1-2.35 2.24 2.292 2.292 0 0 1-2.24-2.35c.43-19.07 13.48-35.12 29.08-35.77 3.49-.15 7.2.55 10.77 1.93 1.11-.49 1.91-.76 2.21-.86 8.15-2.63 18.23-.89 26.94 4.64 7.76 4.93 13.1 12.07 13.94 18.62.38 3 .44 8.63-3.46 12.74-1.1 1.16-5.09 4.85-10.15 3.57-3.63-.92-7.38-4.35-7.17-8.92.15-3.31 2.38-6.35 5.68-7.73 1.17-.49 2.51.06 3.01 1.23.49 1.17-.06 2.51-1.23 3.01-1.67.7-2.8 2.16-2.87 3.71-.1 2.26 2.11 3.85 3.71 4.26 2.64.67 5.03-1.58 5.7-2.28 2.69-2.83 2.46-7.23 2.23-8.99-.67-5.24-5.21-11.11-11.85-15.33-6.79-4.31-14.42-6-20.87-4.72 6.47 4.13 11.45 10.54 11.83 17.96.4 7.83-4.23 17.45-12.4 19.32-.96.22-1.91.32-2.86.32Zm-2.25-35.53c-3.38 1.78-8.18 5.26-9.99 11.21-.71 2.35-1.98 8.38 1.69 13.57 2.58 3.64 7.54 7.06 12.37 5.95 6.18-1.42 9.11-9.4 8.84-14.61-.35-6.91-6.11-12.95-12.92-16.12Z"
          className="cls-6tet3"
        />
        <ellipse
          cx={1100.13}
          cy={1551.19}
          rx={221.68}
          ry={209.44}
          style={{
            fill: "#30770e",
          }}
          transform="rotate(-50.1 1100.24 1551.258)"
        />
        <path
          d="M925.06 1686.24c-56.46-76.98-53-188.77 14.39-269.38 71.86-85.95 191.51-106.66 279.31-52.69-76.66-5.01-162.49 32.72-224.15 106.47-55.22 66.05-78.57 146.05-69.55 215.6Z"
          style={{
            fill: "#387f12",
          }}
        />
        <path
          d="M1261.11 1685.78c-66.38 79.4-173.56 103.11-258.73 63.72 59.69-13.2 125.39-54.6 178.5-118.13 62.89-75.23 92.11-162.33 83.23-229.11 68.02 76.89 68.63 197.82-3 283.51Z"
          style={{
            fill: "#296605",
          }}
        />
        <path
          d="M1162.42 1340.56c5.07 1.21 10.53 2.75 16.3 4.71a183.97 183.97 0 0 1 17.25 6.86c-21.79 1.64-123.46 11.62-202.33 98.67-83.42 92.08-79.01 201.61-77.84 221.65-4.15-6.47-8.33-13.98-12.08-22.56-1.38-3.15-2.6-6.23-3.7-9.21-1.79-17.39-10.4-117.42 62.79-203.95 76.53-90.47 182.81-95.64 199.6-96.17Z"
          className="cls-6tet3"
        />
        <path
          d="M1220.48 1365.23c-34.97 13.73-116.92 51.29-182.94 139.07-65.97 87.7-79.36 176.75-82.87 214.16a92.102 92.102 0 0 1-5.04-4.23 86.235 86.235 0 0 1-7.8-8.03c1.65-32.85 10.68-127.92 82.23-217.76 69.74-87.57 157.42-118.09 189.23-127.53 2.4 1.44 4.8 2.88 7.2 4.31Z"
          className="cls-6tet3"
        />
        <path
          d="M1208.26 1358.15c-27.36 6.17-125.23 31.72-198.32 126.15-70.74 91.39-72.94 188.75-72.54 217.44a83.917 83.917 0 0 1-5.33-6.11 83.6 83.6 0 0 1-4.19-5.8c-.17-27.24 2.49-126.98 77.21-218 73.41-89.42 168.49-112.07 195.54-117.54 2.54 1.29 5.09 2.57 7.63 3.86Z"
          className="cls-6tet8"
        />
        <path
          d="M1261.96 1399.95c-2.75-3.02-5.73-6.11-8.98-9.24-2.21-2.13-4.4-4.15-6.55-6.05-7.87 35.22-20.56 75.66-41.35 118.13-63.86 130.5-166.29 202.84-222.31 236.1 4.58 2.74 9.54 5.48 14.86 8.15 2.95 1.48 5.85 2.84 8.67 4.11 55.66-30.48 184.13-111.58 236.21-264.57 10.35-30.39 16.31-59.61 19.43-86.64Z"
          className="cls-6tet3"
        />
        <path
          d="M1241.27 1379.91c-1.41-1.02-2.83-2.04-4.24-3.06-13.19 38.39-31.8 81.86-58.46 127.2-66.36 112.86-151.32 184.18-210.41 225.18 1.9 1.35 3.79 2.7 5.69 4.04 59.31-37.9 154.41-111.28 220.24-235.6 22.22-41.97 37.08-82.15 47.18-117.76ZM1180.12 1405.51c-28.27 20.05-61.03 47.2-93.24 83.33-57.25 64.19-88.56 129.53-105.84 175.34 9.92-38.91 33.89-110.18 94.89-176.86 36.81-40.24 75.31-65.91 104.2-81.81Z"
          className="cls-6tet8"
        />
        <path
          d="M1294.17 1447.79c-1.03 26.91-7.89 120.57-81.1 204.29-71 81.2-159.35 101.51-186.33 106.65a115.481 115.481 0 0 0 24.89 6.03c21.85-3.35 114.22-20 183.32-104.57 67.42-82.51 66.91-173.61 66.13-196.27a206.773 206.773 0 0 0-6.91-16.13Z"
          className="cls-6tet3"
        />
        <path
          d="M1289.95 1439.5c-4.83 34.71-20.78 115.05-83.92 191.92-69.19 84.25-154.25 114.64-187.37 124.61.95.34 1.91.68 2.89 1.01.74.25 1.47.5 2.2.74 29.71-7.27 124.49-34.46 195.89-126.18 58.94-75.73 70.14-154.59 72.93-187.08-.87-1.67-1.74-3.35-2.61-5.02Z"
          className="cls-6tet8"
        />
        <path
          d="M962.22 1665.3c68.18 172.51 283.84 257.77 493.1 191.02 209.27-66.75 335.72-261.15 291.41-441.27L962.22 1665.3Z"
          className="cls-6tet5"
        />
        <path
          d="M993.12 1655.44c62.64 158.4 261.22 236.52 454.04 175.01 192.83-61.51 309.49-240.19 268.84-405.6l-722.89 230.59Z"
          className="cls-6tet9"
        />
        <path
          d="M1008.01 1650.7c58.94 148.36 248.41 220.49 433.24 161.53 184.84-58.96 297.55-227.48 259.69-382.56L1008 1650.71Z"
          className="cls-6tet2"
        />
        <path
          d="M1008.01 1650.7c58.94 148.36 248.41 220.49 433.24 161.53 184.84-58.96 297.55-227.48 259.69-382.56l-2.82.9c-2.75 130.79-97.19 255.31-241.13 301.23-143.94 45.92-293.03-.92-371.02-105.96l-77.97 24.87Z"
          className="cls-6tet4"
        />
        <ellipse
          cx={1619.19}
          cy={1511.19}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1619.38 1511.33)"
        />
        <ellipse
          cx={1547.26}
          cy={1639.67}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1547.453 1639.837)"
        />
        <ellipse
          cx={1377.89}
          cy={1648.32}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1378.077 1648.462)"
        />
        <ellipse
          cx={1324.05}
          cy={1754.12}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1324.226 1754.277)"
        />
        <ellipse
          cx={1119.39}
          cy={1689.61}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1119.53 1689.778)"
        />
        <ellipse
          cx={1209.97}
          cy={1741.98}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1210.14 1742.152)"
        />
        <ellipse
          cx={1248.45}
          cy={1622.95}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1248.612 1623.084)"
        />
        <ellipse
          cx={1461.62}
          cy={1738.75}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1461.805 1738.927)"
        />
        <ellipse
          cx={1487.14}
          cy={1560.7}
          className="cls-6tet7"
          rx={10.56}
          ry={28.66}
          transform="rotate(-17.69 1487.312 1560.843)"
        />
        <path
          d="M1223.83 1626.72c-90.58 229.19-377.1 342.48-655.13 253.79-278.03-88.69-446.04-346.96-387.17-586.27l1042.3 332.48Z"
          className="cls-6tet5"
        />
        <path
          d="M1182.78 1613.62c-83.23 210.44-347.05 314.24-603.24 232.52s-411.19-319.11-357.18-538.88l960.42 306.36Z"
          className="cls-6tet9"
        />
        <path
          d="M1163 1607.31c-78.31 197.11-330.04 292.94-575.61 214.6-245.58-78.34-395.32-302.23-345.03-508.27L1163 1607.31Z"
          className="cls-6tet2"
        />
        <path
          d="M1163 1607.32c-78.31 197.11-330.03 292.94-575.61 214.6-245.58-78.34-395.32-302.23-345.03-508.27l3.75 1.2c3.66 173.77 129.12 339.2 320.36 400.21 191.24 61 389.32-1.22 492.93-140.78l103.59 33.05Z"
          className="cls-6tet4"
        />
        <ellipse
          cx={350.98}
          cy={1421.97}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 350.956 1421.94)"
        />
        <ellipse
          cx={446.56}
          cy={1592.67}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 446.525 1592.64)"
        />
        <ellipse
          cx={671.58}
          cy={1604.15}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 671.536 1604.13)"
        />
        <ellipse
          cx={743.12}
          cy={1744.72}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 743.068 1744.693)"
        />
        <ellipse
          cx={1015.02}
          cy={1659.02}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 1014.968 1659)"
        />
        <ellipse
          cx={894.67}
          cy={1728.6}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 894.625 1728.574)"
        />
        <ellipse
          cx={843.56}
          cy={1570.45}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 843.511 1570.424)"
        />
        <ellipse
          cx={560.34}
          cy={1724.31}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 560.298 1724.276)"
        />
        <ellipse
          cx={526.43}
          cy={1487.75}
          className="cls-6tet7"
          rx={38.07}
          ry={14.03}
          transform="rotate(-72.31 526.399 1487.721)"
        />
        {children}
      </g>
    </svg>
  );
}
